/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ContactInputs */

const en_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const es_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const fr_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ja_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンタクト`)
};

const zh_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const ar_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتصل بنا`)
};

const id_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak`)
};

const it_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatti`)
};

const ru_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

const pt_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato`)
};

const ko_contact = /** @type {(inputs: ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연락처`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {ContactInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const contact = /** @type {((inputs?: ContactInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ContactInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact(inputs)
	if (locale === "es") return es_contact(inputs)
	if (locale === "fr") return fr_contact(inputs)
	if (locale === "de") return de_contact(inputs)
	if (locale === "ja") return ja_contact(inputs)
	if (locale === "zh") return zh_contact(inputs)
	if (locale === "ar") return ar_contact(inputs)
	if (locale === "id") return id_contact(inputs)
	if (locale === "it") return it_contact(inputs)
	if (locale === "ru") return ru_contact(inputs)
	if (locale === "pt") return pt_contact(inputs)
	return ko_contact(inputs)
});